module.exports = __webpack_public_path__ + "img/Yueting_Zhuang@2x.b34ef49a.png";